import React from 'react';
import {Modal} from '@forecast-it/design-system';
import {ForecastQueryRenderer} from '../../ForecastQueryRenderer';
import SprintBurndownV2Component, {
	sprintBurndownV2ComponentQuery,
} from '../../components/insights/components/sprint_burndown_v2_component';
import {FormattedMessage} from 'react-intl';

export const SprintBurndownModal = ({closeModal, sprintId, isProjectGroupType}) => {
	return (
		<ForecastQueryRenderer
			key="insight_sprint_burndown_v2"
			query={sprintBurndownV2ComponentQuery}
			modal={true}
			showLoader={false}
			variables={{sprintId: sprintId, isProjectGroupType: isProjectGroupType}}
			render={relayProps => (
				<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal}>
					<Modal.Title>Sprint Burndown</Modal.Title>
					<Modal.Content>
						<SprintBurndownV2Component {...relayProps} notifyOnReady={() => {}} selectValue={'remaining-sum'} />
					</Modal.Content>
					<Modal.Footer>
						<Modal.SecondaryFooterButton onPress={closeModal}>
							<FormattedMessage id="common.close" />
						</Modal.SecondaryFooterButton>
					</Modal.Footer>
				</Modal>
			)}
		/>
	);
};
